import { defineMessages, type IntlShape } from 'react-intl';
import {
  ACCOUNT_SLUG_MAX_LENGTH,
  ACCOUNT_SLUG_MIN_LENGTH,
  ACCOUNT_SLUG_REFUSALS,
  type AccountSlugRefusal,
} from 'fym-shared/src/music24/accountSlug';

/** One message for each reason why an address cannot be used (QA 2026-10-28, brk-r2-4). */
const messages = defineMessages({
  tooShort: {
    id: 'app.sml.address.refusal.tooShort',
    defaultMessage: 'Use {min} to {max} letters, numbers or dashes. This address is too short.',
  },
  tooLong: {
    id: 'app.sml.address.refusal.tooLong',
    defaultMessage: 'Use {min} to {max} letters, numbers or dashes. This address is too long.',
  },
  characters: {
    id: 'app.sml.address.refusal.characters',
    defaultMessage: 'Use only letters, numbers and single dashes. A dash cannot start or end the address.',
  },
  reserved: {
    id: 'app.sml.address.refusal.reserved',
    defaultMessage: 'This address is kept for MUSIC24. Pick another one.',
  },
});

/** The refusal of an API answer (`reason`, else `isReserved`), or null. Pure. */
export function slugRefusalOf(answer: { reason?: unknown; isReserved?: unknown }): AccountSlugRefusal | null {
  const { reason } = answer;
  if (typeof reason === 'string' && (ACCOUNT_SLUG_REFUSALS as readonly string[]).includes(reason)) {
    return reason as AccountSlugRefusal;
  }
  return answer.isReserved === true ? 'reserved' : null;
}

/** The line that says why the address cannot be used. */
export function accountSlugRefusalText(intl: IntlShape, refusal: AccountSlugRefusal): string {
  return intl.formatMessage(messages[refusal], { min: ACCOUNT_SLUG_MIN_LENGTH, max: ACCOUNT_SLUG_MAX_LENGTH });
}
